import { useMutation } from '@tanstack/react-query'

import { verifyMFAMessageCode } from '../services/verify-MFA-message-code.service'

export function useVerifyMFAMessageCode() {
  return useMutation({
    mutationFn: verifyMFAMessageCode,
  })
}
